// import PantallaLibro from './pantalla-libro'
// export default PantallaLibro

import PantallaLibroDosPaginasContainer from './containers/pantalla-libro-dos-paginas-container'
export default PantallaLibroDosPaginasContainer